var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.handleOverlayClick($event)}}},[_c('div',{ref:"modal",staticClass:"global-modal-box",on:{"mousedown":function($event){_vm.startedInside = true},"touchstart":function($event){_vm.startedInside = true}}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80ee95ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/GlobalModal.vue
// module id = +82s
// module chunks = 1